import { v4 as uuid } from 'uuid';

const NavbarDefaultRoutes = [
	{
		id: uuid(),
		menuitem: 'Hilfe und Support',
		link: '#',
		children: [
			{
				id: uuid(),
				menuitem: 'Help Center',
				link: '/marketing/help-center/'
			},
			{
				id: uuid(),
				menuitem: "FAQ's",
				link: '/marketing/help-center/faq/'
			},
			{
				id: uuid(),
				menuitem: 'Tutorials',
				link: '/marketing/help-center/guide/'
			},
			{
				id: uuid(),
				menuitem: 'Support Ticket',
				link: '/marketing/help-center/support/'
			},
			{
				id: uuid(),
				menuitem: 'Monitoring / Status',
				link: '/marketing/help-center/statuspage/'
			},
			{
				id: uuid(),
				divider: true
			},
			{
				id: uuid(),
				header: true,
				header_text: 'App',
				description: '',
			},
			{
				id: uuid(),
				menuitem: 'Dashboard',
				link: '#',
				children: [
					{
						id: uuid(),
						header: true,
						header_text: 'Dashboard',
						description:
							'Über das Dashboard können Sie Ihre Daten und Connectoren einsehen und verwalten.'
					},
					{
						id: uuid(),
						divider: true
					},
					{
						id: uuid(),
						menuitem: 'Zum Dashboard',
						link: '/dashboard/overview/',
						type: 'button'
					}
				]
			},
			{
				id: uuid(),
				menuitem: 'Passwort vergessen',
				link: '/authentication/forget-password/'
			},
			{
				id: uuid(),
				badge: 'kostenlos',
				badgecolor: 'primary',
				menuitem: 'Zugang erstellen',
				link: '/authentication/sign-up/'
			}
		]
	}
];

export default NavbarDefaultRoutes;
